import { render, staticRenderFns } from "./taskList.vue?vue&type=template&id=042d62ab&scoped=true&"
import script from "./taskList.vue?vue&type=script&lang=ts&"
export * from "./taskList.vue?vue&type=script&lang=ts&"
import style0 from "./taskList.vue?vue&type=style&index=0&id=042d62ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042d62ab",
  null
  
)

export default component.exports